import { createAction, props } from "@ngrx/store";

export const loadLedgers = createAction('[Ledger] Load Ledgers');
export const loadLedgersSuccess = createAction('[Ledger] Load Ledgers Success', props<{ ledgers: any[] }>());
export const loadLedgersFailure = createAction('[Ledger] Load Ledgers Failure', props<{ error: string }>());
export const addLedger = createAction('[Ledger] Add Ledger', props<{ ledger: any }>());
export const updateLedger = createAction('[Ledger] Update Ledger', props<{ ledger: any; source: 'http' | 'signalr' }>());
export const deleteLedger = createAction('[Ledger] Delete Ledger', props<{ ledgerId: number; source: 'http' | 'signalr' }>());